var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _rect, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogorating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 120,
    viewBox: "0 0 185 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0369 105.366L80.8136 114.841C80.7876 115.945 79.8713 116.819 78.767 116.793L73.7544 116.675",
    stroke: "#FFCB7C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7744 105.502L86.5511 114.977C86.5251 116.082 87.3992 116.998 88.5034 117.024L93.5161 117.142",
    stroke: "#FFCB7C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.92 40.5721C157.992 40.8517 157.85 41.0924 158.558 41.1857C159.199 41.2702 159.886 41.0627 160.085 40.7255C160.283 40.3884 159.759 40.3194 158.92 40.5721Z",
    fill: "#501A2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.649 49.7372C167.531 45.5782 163.984 41.915 163.767 41.5966C163.55 41.278 157.558 42.9861 150.45 45.392C140.183 48.8683 135.393 50.0943 127.131 51.3601C121.413 52.2365 116.594 52.8699 116.422 52.7673C100.68 52.9224 109.019 66.8174 115.157 73.7455C127.264 83.9845 141.699 86.224 156.292 80.1277C166.73 75.7668 177.81 67.805 179.412 63.5152C180.749 59.9312 179.436 57.6007 171.649 49.7372Z",
    fill: "#501A2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6682 106.612L54.0682 4.76812C54.1203 2.55959 55.9528 0.811418 58.1614 0.863465L126.405 2.47172C128.213 2.51434 129.76 3.75874 130.111 5.53323C132.215 16.1472 138.019 52.8994 124.341 81.1937C110.715 109.379 68.328 110.807 55.3762 110.562C53.246 110.522 51.618 108.741 51.6682 106.612Z",
    fill: "#F14F5C",
    stroke: "#CC3945"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.0338,
    cy: 30.517,
    r: 16.2599,
    transform: "rotate(1.35 85.0338 30.517)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.357,
    cy: 31.2084,
    r: 16.2599,
    transform: "rotate(1.35 114.357 31.2084)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.2806,
    y: 43.2907,
    width: 8.74184,
    height: 8.74184,
    rx: 2,
    transform: "rotate(44.1179 99.2806 43.2907)",
    fill: "#FFCB7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2868 21.1577C76.3272 25.1497 77.6387 37.0798 86.2375 38.9038C91.0417 39.9227 96.2685 36.7375 97.4351 32.0796C98.2701 28.7469 97.8052 27.6886 96.0271 28.8726C94.1026 30.1546 91.3382 29.9421 89.8667 28.3996C88.3642 26.8245 88.3052 23.4797 89.7462 21.523C90.7445 20.1663 90.7154 20.128 88.6539 20.0794C87.4892 20.0519 85.5242 20.5369 84.2868 21.1577ZM113.61 21.8487C105.651 25.8408 106.962 37.7708 115.561 39.5948C120.365 40.6137 125.592 37.4285 126.758 32.7706C127.593 29.4379 127.129 28.3797 125.35 29.5637C123.426 30.8456 120.662 30.6331 119.19 29.0906C117.688 27.5155 117.629 24.1707 119.07 22.214C120.068 20.8573 120.039 20.819 117.977 20.7704C116.813 20.743 114.848 21.228 113.61 21.8487Z",
    fill: "#501A2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0711 34.9081C33.9391 34.5909 36.1445 35.0687 39.0037 36.6264C40.8223 37.617 70.0831 70.8017 71.245 73.1907C71.572 73.8631 71.4631 75.5013 71.0034 76.8315C70.2822 78.9186 69.4521 79.7159 64.9395 82.6541C58.4981 86.8477 54.4091 88.7427 49.0119 90.0336C37.4628 92.7957 27.0372 88.9451 17.9717 78.5677C13.665 73.6379 7.90036 65.3666 5.87845 61.2167C3.25131 55.8237 3.6951 55.04 14.8624 45.3529C24.8852 36.6588 26.8845 35.3705 31.0711 34.9081Z",
    fill: "#501A2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogorating);
export default __webpack_public_path__ + "static/media/logorating.7d760a4bbf29715a62c78158e58506b5.svg";
export { ForwardRef as ReactComponent };